export default __webpack_public_path__ + "static/media/input_field_colour.aa7486d6.svg";